import type { ScreenFactory } from "../../taskScreenRegistry";

import { createLifeInsuranceScreens } from "./life_insurance";
import { createLtcInsuranceScreens } from "./ltc_insurance";
import { createMilitaryScreens } from "./military";
import { createEmploymentScreens } from "./employment";

export const benefitsEligibilityTasks: Record<string, ScreenFactory> = {
  life_insurance: createLifeInsuranceScreens,
  ltc_insurance: createLtcInsuranceScreens,
  military: createMilitaryScreens,
  employment: createEmploymentScreens,
};
